import { createSlice } from '@reduxjs/toolkit';

import { thunks } from './thunks';
import { selectors } from './selectors';
import { status } from '../../utils/const';

const initialState = {
  classRoomMedia: null,
  routinesMedia: null,
  mediaMain: null,
  currentMedia: null,
  isPhotoTabSelected: true,

  pagination: {
    total: 0,
    uploadedCount: 20,
  },

  loadingMediaStatus: status.IDLE,
};

const slice = createSlice({
  name: 'media',
  initialState,
  reducers: {
    setCurrentMedia: (state, action) => {
      state.currentMedia = action.payload;
    },
    setIsPhotoTabSelected: (state, action) => {
      state.isPhotoTabSelected = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(thunks.getClassMedia.fulfilled, (state, action) => {
        state.classRoomMedia = action.payload?.data;
      })
      .addCase(thunks.getRoutinesMedia.fulfilled, (state, action) => {
        state.routinesMedia = action.payload?.data;
      })

      .addCase(thunks.getMedia.pending, (state) => {
        state.loadingMediaStatus = status.PENDING;
      })
      .addCase(thunks.getMedia.fulfilled, (state, { payload }) => {
        state.loadingMediaStatus = status.SUCCESS;

        state.pagination.total = payload.totalFilteredCount;
        state.pagination.uploadedCount =
          payload.limitedCount < initialState.pagination.uploadedCount
            ? initialState.pagination.uploadedCount
            : payload.limitedCount;

        state.mediaMain = Object.entries(payload?.data).flatMap(
          ([month, days]) =>
            Object.entries(days).flatMap(([day, items]) =>
              items.map((item) => ({
                ...item,
                date: `${day}, ${month}`, // Додаємо дату з ключів
              }))
            )
        );
      })
      .addCase(thunks.getMedia.rejected, (state) => {
        state.loadingMediaStatus = status.FAIL;
      })

      .addCase(thunks.getMediaById.fulfilled, (state, action) => {
        state.currentMedia = action.payload?.data;
      });
  },
});

const media = {
  actions: slice.actions,
  thunks,
  selectors,
};

export { media };
export default slice.reducer;
